module.exports = "/default/images/vendor/lightgallery.js/dist/youtube-play.png?96bc9d7e27d077372cc0bc9524c500e6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightgallery.js/dist/img/youtube-play.png
// module id = p858
// module chunks = 0